<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import { useDeepClone, usePersonTypes } from '@/composables';
import { PersonStores } from '@/store';

const toast = useToast();

const profileStore = PersonStores.useUserProfileStore();
const { notifications } = storeToRefs(profileStore);

const cloned = ref();

const dirty = ref(false);

const shouldDisplay = computed<boolean>(() => usePersonTypes.isParent() || usePersonTypes.isStudent());

const payload = computed(() => notifications.value.data.filter((item) => item.status).map((item) => item.id));

onMounted(async () => (await profileStore.getNotifications(), defineCloned()));

const defineCloned = () => (cloned.value = useDeepClone(notifications.value.data));

const onCancel = () => {
  notifications.value.data = useDeepClone(cloned.value);
  dirty.value = false;
};

const onSave = () => {
  profileStore.syncNotifications(payload.value);
  defineCloned();
  toast.add({
    severity: 'success',
    summary: 'Saved',
    detail: 'Notifications have been saved',
    life: 3000,
  });
  dirty.value = false;
};

const onStatus = () => (dirty.value = true);
</script>

<template>
  <FormCard v-if="shouldDisplay" title="Notifications" :dirty="dirty" :cancel="onCancel" :save="onSave">
    <template #form>
      <form class="w-full">
        <div v-for="(item, key) in notifications.data" :key="key" class="flex">
          <div class="flex-initial flex align-items-center justify-content-center m-2">
            <InputSwitch v-model="item.status" @input="onStatus" />
          </div>
          <div class="flex-initial flex align-items-center justify-content-center m-2">
            <span v-text="item.title" />
          </div>
        </div>
      </form>
    </template>
  </FormCard>
</template>
